<div class="provider-credential-add-update-container">
    <div *ngIf="stepNo === 1">
        <h1 *ngIf="showFirstSetup === true">Setup your first provider credentials, step 1 of 2</h1>
        <h1 *ngIf="showFirstSetup !== true && operation === 'edit'">Update your provider credentials, step 1 of 2</h1>
        <h2>Enter your <a href="https://www.akahu.nz/" target="_blank">Akahu</a> personal app credentials</h2>
        <div class="provider-credential-instruction-text">Use the form below to setup your inital provider credentials.
        </div>
        <div class="provider-credential-instruction-text">Once you click 'Authenticate' below, IOU will do the following
            with the infromation you have given us:
            <ul>
                <li>Check your credential is valid with <a href="https://www.akahu.nz/" target="_blank">Akahu</a></li>
                <li>If the credential is valid, IOU will get a list of available bank accounts so you to tell IOU which
                    ones to keep tabs on for you.</li>
                <li>IOU will then <strong>encrypt</strong> and store the credential.</li>
                <li>Once the credential is encrypted, <strong>only the background worker process</strong> (not the API's
                    your connecting to right now) <strong>has access to decrypt</strong> your credential to check for
                    updates to your accounts and transactions.</li>
                <li>By design, the <strong>APIs</strong> your web browser communicates with, which retrive data from our
                    database, to show you information, <strong>don't</strong> have access to the keys required to
                    <strong>decrypt</strong> your credentials.</li>
                <li>Put simply, <strong>nothing internet facing has access to decypt your credentials</strong>.</li>
            </ul>
        </div>
        <div class="provider-credential-instruction-text">If you don't have a <a
                href="https://developers.akahu.nz/docs/personal-apps" target="_blank">personal app credential</a> (or
            need to look your current one up), head over to your <a href="https://my.akahu.io/" target="_blank">Akahu
                Profile</a> to get yourself sortted.</div>
        <div [formGroup]="addCredentialForm" fxLayout="column">
            <mat-form-field>
                <mat-label>App ID Token</mat-label>
                <input matInput formControlName="appIdCtl" id="appIdToken" autocomplete="Off" data-lpignore="true">
            </mat-form-field>
            <mat-form-field>
                <mat-label>User Access Token</mat-label>
                <input matInput formControlName="userCredCtrl" type="password" id="userAccessToken" autocomplete="Off"
                    data-lpignore="true">
            </mat-form-field>
            <div fxLayout="row" fxLayoutAlign="center">
                <button mat-raised-button color="accent" (click)="onCancel()" [disabled]="savingCred">{{
                    addCredentialForm.dirty ? 'Cancel' : 'Back'}}</button>&nbsp;
                <button mat-raised-button color="primary" (click)="onSaveCred()"
                    [disabled]="!addCredentialForm.valid || savingCred">{{savingCred ? 'Loading bank accounts...':
                    'Authenticate'}}</button>&nbsp;
            </div>
        </div>
    </div>
    <div *ngIf="stepNo === 2">
        <h1 *ngIf="showFirstSetup === true">Setup your first provider credentials, step 2 of 2</h1>
        <h1 *ngIf="showFirstSetup !== true && operation === 'edit'">Update your provider credentials, step 2 of 2</h1>
        <h2>Choose which accounts to keep an eye on?</h2>
        <div class="provider-credential-instruction-text">Select all the accounts from the list below which you'd like
            to be able to include in IOU.</div>
        <table mat-table [dataSource]="accounts">
            <ng-container matColumnDef="Logo">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let elemet"><img class="provider-credential-bank-logo-image"
                        src="{{elemet.BankLogoUrl}}" /></td>
            </ng-container>

            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let elemet">{{elemet.Name}}</td>
            </ng-container>

            <ng-container matColumnDef="AcctNum">
                <th mat-header-cell *matHeaderCellDef>Number</th>
                <td mat-cell *matCellDef="let elemet">{{elemet.FormattedAccountNumber}}</td>
            </ng-container>

            <ng-container matColumnDef="Select">
                <th mat-header-cell *matHeaderCellDef>Include?</th>
                <td mat-cell *matCellDef="let elemet">
                    <mat-checkbox (change)="onIncludeAccount(elemet.ProviderAccountId, $event)"></mat-checkbox>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="accountsDisplayCols"></tr>
            <tr mat-row *matRowDef="let row; columns: accountsDisplayCols;"></tr>
        </table>
        <div fxLayout="row" fxLayoutAlign="center">
            <button mat-raised-button color="accent" (click)="onCancel()"
                [disabled]="savingAccounts">Back</button>&nbsp;
            <button mat-raised-button color="primary" (click)="onSaveAccounts()"
                [disabled]="accountIdsToInclude.length === 0 || savingAccounts">{{savingAccounts ? 'Setting up bank
                accounts...': 'Confirm'}}</button>&nbsp;
        </div>
    </div>
    <div *ngIf="stepNo === 3">
        <h1 *ngIf="showFirstSetup === true">Setup your first provider credentials is complete</h1>
        <h1 *ngIf="showFirstSetup !== true && operation === 'edit'">Update your provider credentials is complete</h1>
        <div class="provider-credential-instruction-text">Below is the list of accounts IOU you will monitor, you can
            come back here at any time to change which accounts IOU will monitor</div>
        <table mat-table [dataSource]="savedAccounts">
            <ng-container matColumnDef="Logo">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let elemet"><img class="provider-credential-bank-logo-image"
                        src="{{elemet.BankLogoUrl}}" /></td>
            </ng-container>

            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let elemet">{{elemet.Name}}</td>
            </ng-container>

            <ng-container matColumnDef="AcctNum">
                <th mat-header-cell *matHeaderCellDef>Number</th>
                <td mat-cell *matCellDef="let elemet">{{elemet.FormattedAccountNumber}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="savedAccountsDisplayCols"></tr>
            <tr mat-row *matRowDef="let row; columns: savedAccountsDisplayCols;"></tr>
        </table>
        <div fxLayout="row" fxLayoutAlign="center">
            <button mat-raised-button color="primary" (click)="onClickFinish()">Finish</button>&nbsp;
        </div>
    </div>
</div>